import React from "react";
import RightMenu from "@components/RightMenu";

import "./index.scss";

const BottomMobile = () => {
  return (
    <div className="bottom-menu-mobile">
      <RightMenu isMobile={true} />
    </div>
  );
};

export default BottomMobile;
